'use client';

import { useEffect, useState } from 'react';

/** Matches Tailwind `lg`, where mega menu nav items and dropdowns are shown (`hidden lg:flex`). */
export const DESKTOP_MEGA_MENU_QUERY = '(min-width: 1024px)';

/**
 * Whether the desktop mega menu bar is visible. Starts `false` (SSR / mobile) and
 * reconciles from `matchMedia` after mount so mobile never prefetches navigation data.
 */
export function useIsDesktopMegaMenu(): boolean {
    const [isDesktop, setIsDesktop] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia(DESKTOP_MEGA_MENU_QUERY);
        const update = () => setIsDesktop(mediaQuery.matches);
        update();
        mediaQuery.addEventListener('change', update);
        return () => mediaQuery.removeEventListener('change', update);
    }, []);

    return isDesktop;
}
